import { faLinkSimple } from '@fortawesome/pro-regular-svg-icons';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';

import { PlatformApp } from '@typings';
import { cn, tv, VariantProps } from '@utils';
import { buttonVariants } from '@utils/variants';

import { Icon, Link, Popover } from '@components/Shared';

const variants = tv({
  base: 'capitalize flex-1 relative',
  variants: {
    size: {
      medium: '',
      small: 'h-10',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

type Props = VariantProps<typeof variants> & {
  urls: PlatformApp.Instance['endpoints'];
  variant?: VariantProps<typeof buttonVariants>['variant'];
};

export const PlatformAppInstanceUrls: React.FC<Props> = ({
  urls,
  size,
  variant = 'rebecca',
}) => {
  const className = variants({ size });

  if (urls.length === 0) {
    return null;
  }

  if (urls.length === 1) {
    return (
      <Link
        external
        blank
        variant={variant}
        to={urls[0].url}
        className={className}
      >
        Open
        <Icon icon={faExternalLink} />
      </Link>
    );
  }

  return (
    <Popover showArrow={false} side="bottom" triggerClassName="flex-1">
      <div
        slot="trigger"
        className={cn(buttonVariants({ variant }), className, 'w-full')}
      >
        Open
        <Icon size="lg" icon={faLinkSimple} />
      </div>
      <div className="flex min-w-[280px] flex-col gap-1">
        {urls.map(({ url, friendlyName }) => (
          <Link
            external
            blank
            key={url}
            to={url}
            variant="secondary"
            className="h-10 justify-start font-400"
          >
            {friendlyName}
          </Link>
        ))}
      </div>
    </Popover>
  );
};
